import React from 'react';
import {
  Title,
  Outlined,
  Solid,
  ScrollableSolid,
  ScrollableOutlined,
  Top,
  TopRightSection,
  Filled,
  ScrollableFilled,
} from './Container.styles';
import { HudIcon, IconType } from '../Icons/HudIcons';

const ContainerVariants = {
  outlined: Outlined,
  solid: Solid,
  filled: Filled,
};

const ScrollableContainerVariants = {
  outlined: ScrollableOutlined,
  solid: ScrollableSolid,
  filled: ScrollableFilled,
};

export interface ContainerProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'>,
    React.PropsWithChildren {
  variant?: 'outlined' | 'solid' | 'filled';
  title?: string | React.ReactNode;
  scrollable?: boolean;
  topRightSection?: React.ReactNode;
  topRightMargin?: boolean;
  icon?: IconType;
  width?: string;
}

// Modify the function to use forwardRef
export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  (
    {
      variant = 'outlined',
      title,
      icon,
      children,
      topRightSection,
      topRightMargin = true,
      scrollable = false,
      width,
      ...props
    },
    ref,
  ) => {
    const SelectedVariant = ContainerVariants[variant];
    const ScrollableVariant = ScrollableContainerVariants[variant];

    if (scrollable) {
      return (
        <ScrollableVariant ref={ref} style={{ width }} {...props}>
          {title && <Title>{title}</Title>}
          {children}
        </ScrollableVariant>
      );
    }

    return (
      // Pass the ref to the root element
      <SelectedVariant ref={ref} style={{ width }} {...props}>
        {(title || topRightSection) && (
          <Top>
            {(title || icon) && (
              <Title>
                {icon && <HudIcon icon={icon} size="20px" />}
                {title && <span>{title}</span>}
              </Title>
            )}
            {topRightSection && (
              <TopRightSection addRightMargin={topRightMargin}>
                {topRightSection}
              </TopRightSection>
            )}
          </Top>
        )}
        {children}
      </SelectedVariant>
    );
  },
);

// It's a good practice to display a displayName for components using forwardRef,
// especially for debugging purposes.
Container.displayName = 'Container';
